import React, { useRef, useState , useContext } from 'react';
import { useLocation ,useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { postRequest } from '../../lib/api'; // <-- Import your API helper
import toast from 'react-hot-toast';
import { AuthContext } from '../../authContext/context';

export default function OtpScreen() {
  const [values, setValues] = useState(['', '', '', '']);
  const [touched, setTouched] = useState([false, false, false, false]);
  const [loading, setLoading] = useState(false);
  const inputsRef = useRef([]);
  
  const location = useLocation();
  const navigate = useNavigate()
    const authCtx = useContext(AuthContext)
  const userId = location.state?.userId;
  const email = location.state?.email;
  const username = location.state?.username;


  // Handle OTP input change
  const handleChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return; // Only allow single digit
    const newValues = [...values];
    newValues[index] = value;
    setValues(newValues);

    // Move to next input if value entered
    if (value && index < 3) {
      inputsRef.current[index + 1]?.focus();
    }
    // Mark as touched
    const newTouched = [...touched];
    newTouched[index] = true;
    setTouched(newTouched);
  };

  // Handle keyboard navigation
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !values[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    const otp = values.join('');
    // Validation: All boxes must be filled
    if (otp.length < 4 || values.some(v => v === '')) {
      toast.error('Please enter Otp');
      //setTouched([true, true, true, true]);
      return;
    }
    setLoading(true);
    try {
      const payload = { otp, userId };
      const response = await postRequest('auth/otpVerification', payload);
      console.log(response , 'Response@123')
      //toast.success('OTP Verified!');
      if(response?.status == 200){
        authCtx.Login(response?.token?.accessToken, {
          user: {
            userId: response?.data?.userId || userId,
            email: response?.data?.email || email,
            username: response?.data?.username || username,
            userGroup: response?.data?.userGroup
          },
          permissions: response?.data?.permissions
        })
        //toast.success('Login Successful');
        setTimeout(() => navigate('/account/manage',{state:{email:email,username:username}}), 1000);
      }
      
    } catch (err) {
     // toast.error(err?.message || 'OTP verification failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper elevation={4} sx={{ padding: 4, mt: 10, borderRadius: 3 }}>
        <Typography component="h1" variant="h5" align="center" gutterBottom>
          OTP Verification
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center" mb={3}>
          Enter the 4-digit OTP sent to <strong>{email}</strong>
        </Typography>

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Box
            display="flex"
            justifyContent="center"
            gap={2}
            mb={3}
          >
            {values.map((val, index) => (
              <TextField
                key={index}
                inputRef={(el) => (inputsRef.current[index] = el)}
                value={val}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                inputProps={{
                  maxLength: 1,
                  style: {
                    textAlign: 'center',
                    fontSize: '1.5rem',
                    padding: '12px',
                  },
                }}
                sx={{
                  width: 60,
                }}
                error={touched[index] && !val}
                //helperText={touched[index] && !val ? 'Required' : ''}
                disabled={loading}
              />
            ))}
          </Box>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 2, py: 1.5, fontWeight: 'bold' }}
           className='red-bg red-button text-capitalize'
            disabled={loading}
          >
            {loading ? 'Verifying...' : 'Submit OTP'}
          </Button>
        </Box>
         <Box display="flex" justifyContent="center" mt={2}>
    <Button
      startIcon={<ArrowBackIcon />}
      onClick={() => navigate('/login')}
      sx={{ textTransform: 'none', color: '#1976d2' }}
    >
      Back to Login
    </Button>
  </Box>
      </Paper>
    </Container>
  );
}